import * as React from 'react';
import { Alert } from "react-bootstrap";
import { connect } from 'react-redux';
import { removeNewBeneficiary, saveLifeBeneficiaries } from "../../actions/lifePolicyActions";
import { navigateTo } from '../../actions/navigationActions';
import { hideMobileProfile } from '../../actions/profileActions';
import { LIFE_ADD_BENEFICIARY, LIFE_INSURANCE, LIFE_UPDATE_BENEFICIARIES } from "../../routes/routes";
import { UpdatePolicyPayout } from "../Beneficiary/UpdatePolicyPayout";

class LifeUpdatePolicyPayout extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
            options: [],
            changeCounter: 0,
            showPercentageError: false,
        }

        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.changeEdit = this.changeEdit.bind(this);
        this.handlePercentageChange = this.handlePercentageChange.bind(this);
        this.handleUpdatePolicyPayout = this.handleUpdatePolicyPayout.bind(this);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    componentDidMount() {
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        let mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];
        
        if (!mainBenefit) {
            this.handleRedirect(LIFE_INSURANCE);
        }
        
        const options = Array(mainBenefit.beneficiaries.length).fill(1);
        
        const newBeneficiary = this.props.lifePolicy.policy.newBeneficiary;
        this.props.dispatchRemoveNewBeneficiary();
        if (newBeneficiary) {
            mainBenefit.beneficiaries = [...mainBenefit.beneficiaries, newBeneficiary];
        }
        
        this.setState({
            selectedBenefit: {
                ...mainBenefit,
            },
            options,
        });
        
        this.props.dispatchHideProfile();
    }
    
    handleBack() {
        this.handleRedirect(LIFE_INSURANCE);
    }
    
    handleAddBeneficiary() {
        this.handleRedirect(LIFE_ADD_BENEFICIARY);
    }

    changeEdit() {
        this.setState({ isInEdit: !this.state.isInEdit });
    }
    
    changeBeneficiaries(beneficiaries) {
        this.setState((state) => {
            return {
                ...state,
                selectedBenefit: {
                    ...state.selectedBenefit,
                    beneficiaries,
                }
            }
        })
    }

    handlePercentageChange({ percentage, beneficiary }) {
        let beneficiaries = [...this.state.selectedBenefit.beneficiaries];

        if (beneficiaries.length < 2) {
            // Should always be 100% for the one beneficiary there is
            return;
        }

        const benIndex = this.state.selectedBenefit.beneficiaries.indexOf(beneficiary);

        const percentageChange = percentage - beneficiary.percentage;
        const percentageChangeAbs = Math.abs(percentageChange);
        const dividedBetween = Math.floor(percentageChangeAbs / (this.state.selectedBenefit.beneficiaries.length - benIndex - 1));
        const rest = dividedBetween % (this.state.selectedBenefit.beneficiaries.length - benIndex - 1);

        beneficiaries = beneficiaries.reduce((beneficiaries, cur, idx) => {
            cur.percentage = parseInt(cur.percentage, 10);
            if (idx == benIndex) {
                return [
                    ...beneficiaries,
                    {
                        ...cur,
                        percentage,
                    }
                ];
            } else {
                if (benIndex == this.state.selectedBenefit.beneficiaries.length - 1) {
                }
                if (idx == benIndex - 1) {
                }
                if (benIndex == this.state.selectedBenefit.beneficiaries.length - 1 && idx == benIndex - 1) {
                }
                if (idx > benIndex) {
                    if (idx == benIndex + 1 && benIndex != this.state.selectedBenefit.beneficiaries.length - 1) {
                        let p = 0;
                        if (percentageChange > 0) {
                            p = cur.percentage - dividedBetween - rest;
                        } else {
                            p = cur.percentage + dividedBetween + rest;
                        }

                        return [
                            ...beneficiaries,
                            {
                                ...cur,
                                percentage: p,
                            }
                        ];
                    } else if (benIndex == this.state.selectedBenefit.beneficiaries.length - 1 && idx == benIndex - 1) {
                        const p = cur.percentage - dividedBetween;
                        return [
                            ...beneficiaries,
                            {
                                ...cur,
                                percentage: cur.percentage - dividedBetween,
                            }
                        ];
                    } else {
                        const p = cur.percentage - dividedBetween;
                        return [
                            ...beneficiaries,
                            {
                                ...cur,
                                percentage: p,
                            }
                        ];
                    }
                } else {
                    return [
                        ...beneficiaries,
                        cur,
                    ]
                }
            }
        }, []);
        this.changeBeneficiaries(beneficiaries);
    }
    
    async handleUpdatePolicyPayout() {
        const totalPercentage = this.state.selectedBenefit.beneficiaries.map((ben) => ben.percentage).reduce((percentages, percentage) => percentages + percentage, 0);
        if (totalPercentage != 100) {
            this.setState({
                showPercentageError: true,
            });
            return;
        } else {
            this.setState({
                showPercentageError: false,
            });
        }
        await this.props.dispatchSaveBeneficiaries(this.state.selectedBenefit.id, this.state.selectedBenefit.beneficiaries);
        this.handleRedirect(LIFE_UPDATE_BENEFICIARIES);
    }

    public render() {
        const beneficiary = this.state.selectedBenefit?.beneficiaries?.filter((beneficiary) => beneficiary.id === this.props.lifePolicy.policy.activeBeneficiaryId)[0];
        return <>
            { this.state.selectedBenefit?.beneficiaries?.length > 0 &&
                <>
                    <>{ this.state.showPercentageError && <Alert variant="danger" dismissible>Please make sure the percentages add up to 100%</Alert> }</>
                    <UpdatePolicyPayout emitHandleUpdatePolicyPayout={this.handleUpdatePolicyPayout} selectedBenefit={this.state.selectedBenefit} emitHandlePercentageChange={this.handlePercentageChange} beneficiary={beneficiary} emitHandleAddBeneficiary={this.handleAddBeneficiary} emitHandleBack={this.handleBack} />
                </>
            }
        </>
    }

}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        dispatchSaveBeneficiaries: (benefitId: any, beneficiaries: any) => dispatch(saveLifeBeneficiaries(benefitId, beneficiaries)),
        dispatchRemoveNewBeneficiary: () => dispatch(removeNewBeneficiary()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeUpdatePolicyPayout);